<template>
    <v-card-text>
        <v-row>
            <v-col class="pb-6">
                <date-picker 
                    v-model="fechas" @change="cargarMuestreos(fechas)"
                    range-separator="|" range placeholder ="Búsqueda por Fechas de Producción (Lote)" 
                    format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD">
                </date-picker>
            </v-col>
            <v-col>
                <v-btn class="float-right" color="green" dark @click="exportarExcel()">
                    Exportar informes Excel
                    <v-icon>save</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :items="informes_filtrados"
            :headers="encabezado"
            class="text-center"
        >
            <template v-slot:header="{ props: { headers }}">
                <tr>
                    <th v-for="cab in headers" class="filita px-2">
                        <v-text-field
                            v-if="cab.value === 'nombre_informe'"
                            label="Buscar por informe"
                            v-model="filtros.nombre_informe"
                        ></v-text-field>
                        <v-text-field
                            v-else-if="cab.value === 'lote'"
                            label="Buscar por lote"
                            v-model="filtros.lote"
                        ></v-text-field>
                    </th>
                </tr>
            </template>
            <template v-slot:item.fecha_prod_lote="{ item }">
                <td>
                    {{ item.fecha_prod_lote | formatearFecha }}
                </td>
            </template>
            <template v-slot:item.fecha_vencimiento="{ item }">
                <td>
                    {{ item.fecha_vencimiento | formatearFecha }}
                </td>
            </template>
            <template v-slot:item.actions="{ item }">
                <td class="d-flex justify-center align-center">
                    <v-btn color="green" dark small @click="cargarMuestreo(item)">
                        <v-icon>bar_chart</v-icon>
                    </v-btn>
                </td>
            </template>
        </v-data-table>
        <modal-muestreos></modal-muestreos>
    </v-card-text>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// Modal
import ModalMuestreos from '@/components/shared/Modal_Muestreos.vue'

export default {
    data: () => ({
        fechas: new Date().toISOString().substring(0, 10),
        informes: [],
        encabezado: [
            { text: 'Laboratorio', value: 'laboratorio', class:"cabecera" },
            { text: 'Nombre(s) Informe(s)', value: 'nombre_informe', class:"cabecera" },
            { text: 'Lote', value: 'lote', class:"cabecera" },
            { text: 'Fecha Prod. Lote', value: 'fecha_prod_lote', class:"cabecera" },
            { text: 'Fecha Vencimiento', value: 'fecha_vencimiento', class:"cabecera" },
            { text: 'Acciones', value: 'actions', sortable: false, class:"cabecera"},
        ],
        filtros: {
            nombre_informe: '',
            lote: '',
        },
    }),
    mounted() {
        this.cargarMuestreos();
    },
    methods: {
        async exportarExcel() {
            let url = `${this.base_url}informe_muestreo/exportar_excel`;
            if (typeof this.fechas == 'object' && this.fechas.length == 2) {
                url = url + `?fecha_ini=${this.fechas[0]}&fecha_fin=${this.fechas[1]}`;
            }
            this.axios.get(url, this.headers).then(res => {
                console.log(res);
                window.location.href = this.download_url.replace('bitacoras', 'informe_muestreos') + res.data.data;
            }).catch(error => {
                console.log('error',error);
            });
        },

        async cargarMuestreos(fechas) {
            this.mostrarLoading({ titulo: 'Obteniendo informes de muestreos...', color: 'green' });
            let url = `${this.base_url}informes_muestreos`;
            
            if(fechas) {
                url = url + `?fecha_ini=${fechas[0]}&fecha_fin=${fechas[1]}`
            }
            
            this.axios.get(url, this.headers).then(res => {
                this.informes = res.data.data.map(informe => {
                    informe.nombre_informe = informe.nombre_informe.split(";").join(', ');
                    return informe;
                });
                this.ocultarLoading();
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al obtener datos de informes");
            });
        },
        cargarMuestreo(item) {
            Event.$emit('abrir_modal_muestreos', item);
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },

    computed: {
        informes_filtrados() {
            if(Object.values(this.filtros).every(filtro => filtro === '')) {
                return this.informes;
            }

            return this.informes.filter(informe => {
                let filtrado = true;
                if(this.filtros.nombre_informe) {
                    filtrado = informe.nombre_informe.toLowerCase().includes(this.filtros.nombre_informe.toLowerCase());
                    if(!filtrado) return false;
                } 
                if(this.filtros.lote) {
                    filtrado = informe.lote.toLowerCase().includes(this.filtros.lote.toLowerCase());
                    if(!filtrado) return false;
                }
                return filtrado;
            });
        },
        ...mapState(['base_url', 'headers', 'download_url']),
    },

    components: {
        DatePicker,
        'modal-muestreos': ModalMuestreos,
    }
}

</script>

<style scoped></style>